const getInactive = data =>
  (!Array.isArray(data) && Boolean(data && typeof data === 'object' && data.isInactive))
    || (Array.isArray(data) && data.some(d => Boolean(d && typeof d === 'object' && d.isInactive)));

export default getInactive;